import { render } from "./PropertiesConfigTab.vue?vue&type=template&id=cc200754"
import script from "./PropertiesConfigTab.vue?vue&type=script&lang=js"
export * from "./PropertiesConfigTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__